module.exports = __webpack_public_path__ + "static/media/Magnifying.340abbdb.svg";